module.exports = __webpack_public_path__ + "static/media/colicoli04.ce8ebdf0.webp";